import React from 'react';
import './primary-button.css';

export default function PrimaryButton({ icon: Icon, text, bgColor = '#E30613', onClick, disabled = false, width, className = ''}) {
  return (
    <button
      className={`primary-button ${disabled ? 'disabled' : ''} ${className}`}
      style={{ backgroundColor: disabled ? '#A9A9A9' : bgColor , width: width}}
      onClick={!disabled ? onClick : undefined}
      disabled={disabled}
    >
      {Icon && <Icon className="button-icon"  style={{ marginRight: text ? '8px' : '0' }} />}
      {text}
    </button>
  );
}